import { useState } from "react";
import { RotateCcw, AlertTriangle, X } from "lucide-react";
import { useTranslation } from "../../i18n";
import type { DispatchOrder, DispatchBox } from "../../types/Dispatch";

// Title-bar "reopen last shipped order" button + its warning modal.
// Shared by the scan-item AND scan-tote screens so the operator can always
// pull back the order they just completed — including right after the
// tote's last order ships and the flow returns to the tote scan.
type Props = {
    lastOrder: { order: DispatchOrder; boxes: DispatchBox[] } | null | undefined;
    onReopen: (data: { order: DispatchOrder; boxes: DispatchBox[] }) => void;
};

const DispatchReopenButton = ({ lastOrder, onReopen }: Props) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    if (!lastOrder) return null;

    return (
        <>
            {/* Says what it does — it used to be just the order number. */}
            <button
                type="button"
                className="dispatch-reopen-btn"
                onClick={() => setShowModal(true)}
            >
                <RotateCcw size={16} aria-hidden="true" />
                {t("reopen_order")}
                <span className="dispatch-reopen-btn-number">#{lastOrder.order.order_number}</span>
            </button>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-card" onClick={e => e.stopPropagation()}>
                        <div className="modal-card-header">
                            <h2>{t("reopen_order")}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}><X size={18} /></button>
                        </div>
                        <div className="modal-card-body">
                            <div className="dispatch-reopen-warning-icon">
                                <AlertTriangle size={32} />
                            </div>
                            <p className="dispatch-reopen-warning-order">#{lastOrder.order.order_number}</p>
                            <p className="dispatch-reopen-warning-text">{t("reopen_warning")}</p>
                            <div className="modal-confirm-buttons" style={{ marginTop: 20 }}>
                                <button className="btn btn-ghost btn-lg" onClick={() => setShowModal(false)}>
                                    {t("cancel")}
                                </button>
                                <button className="btn btn-danger btn-lg" onClick={() => { setShowModal(false); onReopen(lastOrder); }}>
                                    <RotateCcw size={22} />
                                    {t("reopen_order")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DispatchReopenButton;
